import Sidebar from '../utill/Sidebar'
import Header from "../utill/Header";
import Footer from "../utill/Footer";
import {Card, Form, Table} from "react-bootstrap";
import React, {useState, useEffect, useContext, ChangeEvent} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {AesEncrypt, reissue} from "../utill/UtilComponent";
import styles from "../../css/Authority.module.css";
import {RootState} from "../../redux/store";
import passwordValid from "../utill/passwordValid";
import { MESSAGES } from "../utill/Messages";

interface User {
    userId: string;
    password: string;
    userName: string;
    customerName: string;
    authorityName: string;
}


function WebUserModify() {
    const url = useContext(Url)
    const location = useLocation();
    const navigate = useNavigate();
    const selectedId = location.state?.id
    const [passwd, setPasswd] = useState('');
    const [passwdCheck, setPasswdCheck] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState({text: '', color: ''});
    const [customerCode, setCustomerCode] = useState<CustomerCode[]>([]);
    const [customerCodeSelected, setCustomerCodeSelected] = useState("");
    const [authority, setAuthority] = useState<AuthorityName[]>([]);
    const [authoritySelected, setAuthoritySelected] = useState("");
    const nowUser = useSelector((state: RootState) => state.user.value);
    const [data, setData] = useState<User[]>([]);
    let userId = nowUser.id;
    const [user, setUser] = useState<User>({
        userId: location.state?.id,
        password: '',
        userName: location.state?.userName,
        customerName:location.state?.customerName,
        authorityName:location.state?.authorityName
    });
    const auth = useSelector((state: RootState) => state.loginAuth.value);

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-웹 계정 수정'
        if (auth.MENUAUTH?.SET0300?.writeAuthorityYn !== "1" && auth.MENUAUTH?.SET0300?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.')
            navigate(auth.firstUrl);
        } else if (auth.MENUAUTH?.SET0300?.writeAuthorityYn !== "1") {
            navigate('/WebUserManagement');
        }
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'customercode/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setCustomerCode(response.data.result.data)
            })
            axios.get(url + 'authority/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setAuthority(response.data.result.data)
            })
            axios.get(url + 'admin/find/sameid',{
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params:{
                    userId: user.userId,
                }
            }).then((response) =>{
                setCustomerCodeSelected(response.data.result[0].customerCode ? response.data.result[0].customerCode : "")
                setAuthoritySelected(response.data.result[0].authorityId)
            })
        })
    }, []);

    const handlePasswdChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setPasswd(value);

        if (value === '') {
            setError('');
        } else {
            if (passwordValid(value)) {
                setError('');
                setDisabled(false);
            } else {
                setError(MESSAGES.PASSWORD.INVALID);
                setDisabled(false);
            }
        }
    };

    const handlePasswdCheckChange = (e: ChangeEvent<HTMLInputElement>) => {
        setPasswdCheck(e.target.value);
    };

    useEffect(() => {
        if ((passwd !== passwdCheck) || !passwordValid(passwd)) {
            setMessage({text: MESSAGES.PASSWORD.MISMATCH, color: "red"});
            setDisabled(true);
        } else if (passwd === passwdCheck) {
            setMessage({text: MESSAGES.PASSWORD.CORRECT, color: "green"});
            setDisabled(false);
        }
        if (!passwd && !passwdCheck) {
            setMessage({text: '', color: ''});
        }
    }, [passwd, passwdCheck]);

    const handleUpdateUser = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            const Update = window.confirm(`유저 ID: ${selectedId}님의 정보를 수정하시겠습니까?`)
            if (Update) {
                axios.put(url + 'admin/update', {
                    userId: selectedId,
                    password: AesEncrypt(passwd),
                    userName: user.userName,
                    customerCode: customerCodeSelected,
                    authorityId: authoritySelected,
                    loginId: nowUser.id
                }, {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization')
                    }
                })
                    .then(res => {
                        alert('유저 정보가 수정되었습니다.');
                        navigate('/WebUserManagement');
                    })
                    .catch(error => {
                        console.log(error);
                        alert('유저 정보 수정에 실패하였습니다.');
                    });
            } else {
                console.log(e);
            }
        })
    }

    const handleDeleteUser = (id: string) => {
        reissue(userId, url, navigate).then(() => {
            const Delete = window.confirm(`유저 ID: ${id}의 정보를 삭제 하시겠습니까?`);
            if (Delete) {
                try {
                    axios.delete(url + `admin/delete/${id}`, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    })
                        .then(res => {
                            alert('유저 정보가 삭제 되었습니다.');
                            const updatedData = data.filter(user => user.userId !== id);
                            setData(updatedData);
                            navigate('/WebUserManagement')
                        })
                } catch (e) {
                    console.error(e);
                    alert('삭제 실패 하였습니다.');
                }
            }
        })
    }

    const handleModifyCancel = () => {
        reissue(userId, url, navigate).then(() => {
            const Cancel = window.confirm('취소하시겠습니까?');
            if (Cancel) {
                navigate('/WebUserManagement');
            }
        })
    }

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setUser({...user, [e.target.name]: e.target.value});
    };

    const handleChangeCustomerCodeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setCustomerCodeSelected(e.target.value)
    }
    
    const handleChangeAuthoritySelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setAuthoritySelected(e.target.value)
    }


    return (
        <div id="wrapper">
            <Sidebar menuCode={"SET0300"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='웹 계정 수정'/>
                        <Card className="card shadow mb-4">
                            <Card.Body style={{margin:'1rem'}}>
                                <Table bordered>
                                    <tbody>
                                        <tr>
                                            <td style={{width:"20%", height:"3rem", verticalAlign: "middle"}} className={styles.tableHead}><p>아이디</p></td>
                                            <td style={{width:"80%", verticalAlign:"middle", color:"black"}}><p>{selectedId}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{width:"20%"}} className={styles.tableHead}><p>비밀번호</p></td>
                                            <td style={{width:"80%"}}>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <Form.Control
                                                            type="password"
                                                            placeholder="비밀번호"
                                                            name="password"
                                                            value={passwd}
                                                            onChange={handlePasswdChange}
                                                        />
                                                        {error && <p style={{ marginTop: '4px' }}>{error}</p>}
                                                    </div>
                                                    <p style={{ marginLeft: '1rem', marginTop: '10px' }}>
                                                        {MESSAGES.PASSWORD.FORMAT}
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{width:"20%"}} className={styles.tableHead}><p>비밀번호 확인</p></td>
                                            <td style={{width: "80%"}}>
                                                <Form.Control type="password" placeholder="비밀번호 확인" name="passwdCheck"
                                                              value={passwdCheck} onChange={handlePasswdCheckChange}/>
                                                <p className="errormessage" style={{color: message.color}}>{message.text}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{width:"20%"}} className={styles.tableHead}><p>회원명</p></td>
                                            <td style={{width:"80%"}}>
                                                <Form.Control type="text" placeholder="회원명" name="userName"
                                                              value={user.userName} onChange={handleChange}/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{width:"20%"}} className={styles.tableHead}><p>회사명</p></td>
                                            <td style={{width:"80%"}}>
                                                <Form.Select className="select_box device" value={customerCodeSelected}
                                                             onChange={handleChangeCustomerCodeSelect} name="customerCode">
                                                    {customerCode.map(customerCode => (
                                                        <option key={customerCode.customerCode}
                                                                value={customerCode.customerCode}>{customerCode.customerName}</option>
                                                    ))}
                                                    <option value=''>텔레컨스</option>
                                                </Form.Select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{width:"20%"}} className={styles.tableHead}><p>권한명</p></td>
                                            <td style={{width:"80%"}}>
                                                <Form.Select className="select_box device" value={authoritySelected}
                                                             onChange={handleChangeAuthoritySelect} name="authority">
                                                    {authority.map(authority => (
                                                        <option key={authority.authorityId}
                                                                value={authority.authorityId}>{authority.authorityName}</option>
                                                    ))}
                                                </Form.Select>
                                            </td>
                                        </tr>

                                    </tbody>
                                </Table>
                                <div className="btn modify">
                                    <button className="btn btn-primary" disabled={disabled}
                                            onClick={handleUpdateUser}>수정
                                    </button>
                                    <button className="btn btn-danger"
                                            onClick={() => handleDeleteUser(user.userId)}>삭제</button>
                                    <button className="btn btn-secondary cancel" onClick={handleModifyCancel}>취소
                                    </button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default WebUserModify;